/* DirectBlanks Go Custom + Wholesale v2: inquiry form + video button.
   Form flow (one click, two native Shopify posts, sequential, form-urlencoded):
     1) contact form  -> POST /contact form_type=contact (all fields, joined multi-choice answers)
     2) customer form -> POST /contact form_type=customer (email, first/last name, tags[, accepts_marketing])
   If Shopify answers with its captcha page (/challenge) the contact form is submitted normally; the customer step
   is kept in sessionStorage and finished after Shopify redirects back (?contact_posted=true).
   Book a call (Calendly): the widget script loads only when a [data-dbg-book] section nears the viewport or a
   button opens it. Prefill (designed form only) goes in the Calendly URL: name, email, and phone as a1/a2/a3/location.
   Loaded once per page even when several sections include it. */
(function () {
  if (window.DBXBiz) return;
  var DBX = (window.DBXBiz = { version: 1 });
  var EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
  var PHONE_RE = /^\+?[\d\s().\-\/]+((x|ext\.?)\s*\d{1,6})?$/i;
  var CAL_JS = 'https://assets.calendly.com/assets/external/widget.js';
  function phoneOk(v) {
    var main = v.replace(/(x|ext\.?)\s*\d{1,6}$/i, '');
    var digits = main.replace(/\D/g, '').length;
    return PHONE_RE.test(v) && digits >= 7 && digits <= 15;
  }
  function einFormat(v) {
    var d = String(v || '').replace(/\D/g, '').slice(0, 9);
    return d.length > 2 ? d.slice(0, 2) + '-' + d.slice(2) : d;
  }
  DBX.phoneOk = phoneOk;
  DBX.einFormat = einFormat;
  var store = {
    get: function (k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  function splitName(full) {
    var parts = String(full || '').trim().split(/\s+/).filter(Boolean);
    return { first: parts.shift() || '', last: parts.join(' ') };
  }

  function isChallenge(res) {
    return !!res && (/\/challenge/.test(res.url || '') || res.status === 429);
  }

  function post(url, params) {
    return fetch(url, {
      method: 'POST',
      body: params.toString(),
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'text/html' }
    });
  }

  /** contact params from the real form; checkbox groups are joined into one contact[Question] answer */
  function contactParams(form) {
    var fd = new FormData(form);
    var params = new URLSearchParams();
    var groups = {};
    form.querySelectorAll('fieldset[data-group][data-multiple="true"]').forEach(function (fs) {
      var key = fs.getAttribute('data-group');
      var vals = [];
      fs.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
        groups[cb.name] = key;
        if (cb.checked) vals.push(cb.getAttribute('data-value') || cb.value);
      });
      groups['__' + key] = vals.join(', ');
    });
    var done = {};
    fd.forEach(function (v, k) {
      if (typeof v !== 'string') return;
      if (groups[k]) {
        var key = groups[k];
        if (!done[key]) { done[key] = 1; params.append('contact[' + key + ']', groups['__' + key]); }
        return;
      }
      params.append(k, v);
    });
    // a group with nothing ticked still shows up (optional questions)
    Object.keys(groups).forEach(function (k) {
      if (k.indexOf('__') === 0) {
        var key = k.slice(2);
        if (!done[key] && !params.has('contact[' + key + ']')) params.append('contact[' + key + ']', groups[k]);
      }
    });
    return params;
  }

  function customerParams(cform, data) {
    var params = new URLSearchParams();
    new FormData(cform).forEach(function (v, k) { if (typeof v === 'string') params.set(k, v); });
    params.set('form_type', 'customer');
    params.set('contact[email]', data.email);
    if (data.first) params.set('contact[first_name]', data.first); else params.delete('contact[first_name]');
    if (data.last) params.set('contact[last_name]', data.last); else params.delete('contact[last_name]');
    params.set('contact[tags]', data.tags);
    if (data.optin) params.set('contact[accepts_marketing]', 'true');
    return params;
  }

  function setupForm(wrap) {
    if (wrap.hasAttribute('data-dbg-ready')) return;
    wrap.setAttribute('data-dbg-ready', '');
    var sid = wrap.getAttribute('data-section');
    var form = wrap.querySelector('form.dbg-form');
    var cform = wrap.querySelector('form.dbg-hidden-form');
    var done = wrap.querySelector('[data-dbg-done]');
    var card = wrap.querySelector('[data-dbg-card]');
    var status = wrap.querySelector('[data-dbg-status]');
    var btn = wrap.querySelector('[data-dbg-submit]');
    var cfg = {};
    try { cfg = JSON.parse(wrap.querySelector('[data-dbg-config]').textContent); } catch (e) {}
    var KEY_DONE = 'dbg-done-' + sid, KEY_PENDING = 'dbg-pending-' + sid;
    if (!form) return;
    form.noValidate = true;

    function say(msg, isErr) {
      if (!status) return;
      status.textContent = '';
      status.classList.toggle('is-error', !!isErr);
      // re-set on the next frame so screen readers announce repeats
      requestAnimationFrame(function () { status.textContent = msg || ''; });
    }

    function fillDone(data) {
      if (!done) return;
      done.querySelectorAll('[data-dbg-name]').forEach(function (el) {
        var sep = el.getAttribute('data-sep') || '';
        el.textContent = data && data.first ? sep + data.first : '';
      });
      done.querySelectorAll('[data-dbg-email]').forEach(function (el) { el.textContent = (data && data.email) || ''; });
      done.querySelectorAll('[data-dbg-when]').forEach(function (el) {
        el.hidden = !(data && data.checks && data.checks.indexOf(el.getAttribute('data-dbg-when')) > -1);
      });
    }

    function showDone(data, focus) {
      fillDone(data);
      if (card) card.hidden = true;
      if (done) {
        done.hidden = false;
        if (focus) {
          done.focus({ preventScroll: true });
          done.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      }
      DBX.lastSubmit = data;
      var bookP = done && done.querySelector('[data-dbg-book-after]');
      if (bookP) {
        var a = bookP.querySelector('[data-dbg-book-go]');
        var target = a && document.getElementById((a.getAttribute('href') || '').slice(1));
        bookP.hidden = !(target && target.querySelector('[data-dbg-book]'));
        if (a && !a.hasAttribute('data-dbg-ready')) {
          a.setAttribute('data-dbg-ready', '');
          a.addEventListener('click', function (ev) {
            var t = document.getElementById((a.getAttribute('href') || '').slice(1));
            var box = t && t.querySelector('[data-dbg-book]');
            if (!box) return;
            ev.preventDefault();
            DBX.openBook(box, data, true);
          });
        }
      }
      wrap.dispatchEvent(new CustomEvent('dbg:submitted', { bubbles: true, detail: { section: sid } }));
    }

    function clearField(el) {
      var fg = el.closest('.dbg-fg');
      if (fg && fg.classList.contains('is-bad')) {
        fg.classList.remove('is-bad');
        fg.querySelectorAll('[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
        if (fg.tagName === 'FIELDSET') fg.removeAttribute('aria-invalid');
      }
    }
    form.addEventListener('input', function (e) {
      clearField(e.target);
      if (e.target.hasAttribute && e.target.hasAttribute('data-ein')) {
        var el = e.target, f = einFormat(el.value);
        if (f !== el.value) {
          var digitsBefore = el.value.slice(0, el.selectionStart || 0).replace(/\D/g, '').length;
          el.value = f;
          var pos = digitsBefore > 2 ? digitsBefore + 1 : digitsBefore;
          try { el.setSelectionRange(pos, pos); } catch (err) {}
        }
      }
    });
    form.addEventListener('change', function (e) { clearField(e.target); });

    function validate() {
      var first = null;
      form.querySelectorAll('input[required], select[required], textarea[required]').forEach(function (el) {
        var v = (el.value || '').trim();
        var ok = v !== '' && (el.type !== 'email' || EMAIL_RE.test(v)) && (el.type !== 'tel' || phoneOk(v)) && (!el.hasAttribute('data-ein') || v.replace(/\D/g, '').length === 9);
        var fg = el.closest('.dbg-fg');
        if (fg) fg.classList.toggle('is-bad', !ok);
        if (!ok) { el.setAttribute('aria-invalid', 'true'); if (!first) first = el; } else el.removeAttribute('aria-invalid');
      });
      // optional email fields must still look like an email
      // optional email / phone / EIN fields must still be well-formed when filled in
      form.querySelectorAll('input[type="email"]:not([required]), input[type="tel"]:not([required]), input[data-ein]:not([required])').forEach(function (el) {
        var v = (el.value || '').trim();
        var good = !v || (el.type === 'email' ? EMAIL_RE.test(v) : el.type === 'tel' ? phoneOk(v) : v.replace(/\D/g, '').length === 9);
        if (!good) { el.closest('.dbg-fg').classList.add('is-bad'); el.setAttribute('aria-invalid', 'true'); if (!first) first = el; }
      });
      form.querySelectorAll('fieldset[data-req]').forEach(function (fs) {
        var ok = !!fs.querySelector('input:checked');
        fs.classList.toggle('is-bad', !ok);
        if (!ok) { fs.setAttribute('aria-invalid', 'true'); if (!first) first = fs.querySelector('input'); } else fs.removeAttribute('aria-invalid');
      });
      return first;
    }

    function collect() {
      var nameEl = form.querySelector('[data-role="name"]');
      var emailEl = form.querySelector('[data-role="email"]');
      var phoneEl = form.querySelector('[data-role="phone"]');
      var n = splitName(nameEl ? nameEl.value : '');
      var optEl = form.querySelector('input[data-optin]');
      var checks = [];
      form.querySelectorAll('input[type="checkbox"][data-key]').forEach(function (cb) { if (cb.checked) checks.push(cb.getAttribute('data-key')); });
      return {
        first: n.first, last: n.last,
        name: nameEl ? nameEl.value.trim() : '',
        phone: phoneEl ? phoneEl.value.trim() : '',
        email: emailEl ? emailEl.value.trim() : '',
        optin: !!(optEl && optEl.checked),
        checks: checks,
        tags: cfg.tags || ''
      };
    }

    function wantsCustomer(data) {
      if (!cform || !data.email || !data.tags && !data.optin) return false;
      if (cfg.customerStep === 'off') return false;
      if (cfg.customerStep === 'optin') return data.optin;
      return true;
    }

    function busy(on) {
      if (!btn) return;
      if (on) { btn.dataset.label = btn.textContent; btn.textContent = cfg.sending || btn.textContent; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      else { btn.textContent = btn.dataset.label || btn.textContent; btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }

    function nativeSubmit(data) {
      // Shopify shows its own captcha / errors; we finish the customer step when it sends them back.
      store.set(KEY_DONE, data);
      if (wantsCustomer(data)) store.set(KEY_PENDING, data);
      form.submit();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = validate();
      if (bad) {
        say(cfg.errSummary || 'Please fix the fields marked in red.', true);
        bad.focus();
        return;
      }
      var data = collect();
      busy(true);
      say(cfg.sending || '');
      var fallback = false;
      post(form.getAttribute('action') || '/contact', contactParams(form))
        .then(function (res) {
          if (isChallenge(res)) { fallback = true; nativeSubmit(data); return 'native'; }
          if (!res.ok) throw new Error('HTTP ' + res.status);
          // Shopify redirects a good post to ?contact_posted=true; anything else means it re-rendered with errors.
          if (!/contact_posted=true/.test(res.url || '')) { fallback = true; nativeSubmit(data); return 'native'; }
          if (!wantsCustomer(data)) return 'ok';
          return post(cform.getAttribute('action') || '/contact', customerParams(cform, data)).then(function (r2) {
            if (isChallenge(r2)) { store.set(KEY_DONE, data); cformSubmit(data); return 'native'; }
            return 'ok';
          }, function () { return 'ok'; /* the email already went out; tagging is best effort */ });
        })
        .then(function (r) {
          if (r === 'native') return;
          busy(false);
          store.del(KEY_PENDING);
          say(cfg.sent || 'Sent.');
          showDone(data, true);
        })
        .catch(function () {
          if (fallback) return;
          busy(false);
          say(cfg.errSend || 'Something went wrong. Please try again.', true);
        });
    });

    function cformSubmit(data) {
      var p = customerParams(cform, data);
      ['contact[email]', 'contact[first_name]', 'contact[last_name]', 'contact[tags]'].forEach(function (k) {
        var el = cform.querySelector('[name="' + k + '"]');
        if (el) el.value = p.get(k) || '';
      });
      if (data.optin && !cform.querySelector('[name="contact[accepts_marketing]"]')) {
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'contact[accepts_marketing]'; i.value = 'true'; cform.appendChild(i);
      }
      cform.submit();
    }

    // Back from a normal (non-JS or captcha) post
    var qs = location.search;
    var saved = store.get(KEY_DONE);
    if (/contact_posted=true/.test(qs) || /customer_posted=true/.test(qs)) {
      var pending = store.get(KEY_PENDING);
      if (pending && /contact_posted=true/.test(qs) && cform) {
        store.del(KEY_PENDING);
        post(cform.getAttribute('action') || '/contact', customerParams(cform, pending)).then(function (r) {
          if (isChallenge(r)) cformSubmit(pending);
        }, function () {});
      }
      if (saved || (done && done.hasAttribute('data-server-posted'))) {
        showDone(saved || {}, false);
        store.del(KEY_DONE);
      }
    } else if (done && done.hasAttribute('data-server-posted')) {
      fillDone(saved || {});
    }
    DBX._forms = (DBX._forms || 0) + 1;
  }

  function setupVideo(box) {
    if (box.hasAttribute('data-dbg-ready')) return;
    box.setAttribute('data-dbg-ready', '');
    var v = box.querySelector('video');
    var b = box.querySelector('[data-dbg-play]');
    if (!v || !b) return;
    function sync() {
      var playing = !v.paused && !v.ended;
      box.classList.toggle('is-playing', playing);
      b.setAttribute('aria-label', playing ? b.getAttribute('data-label-pause') : b.getAttribute('data-label-play'));
      b.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }
    var auto = box.hasAttribute('data-dbg-autoplay');
    var userPaused = false, inView = false;
    function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    b.addEventListener('click', function () { if (v.paused || v.ended) { userPaused = false; play(); } else { userPaused = true; v.pause(); } });
    v.addEventListener('click', function () { if (!v.paused) { userPaused = true; v.pause(); } });
    ['play', 'pause', 'ended'].forEach(function (ev) { v.addEventListener(ev, sync); });
    sync();
    // Autoplay: muted loop that runs only while on screen. Reduced motion keeps the poster (play button still works).
    if (!auto) return;
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
    var rm = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
    function reduced() { return !!(rm && rm.matches); }
    function update() {
      if (inView && !userPaused && !reduced()) {
        if (v.preload === 'none') v.preload = 'auto';
        if (v.paused) play();
      } else if (!inView && !v.paused) v.pause();
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries.some(function (en) { return en.isIntersecting; });
        update();
      }, { rootMargin: '150px 0px', threshold: 0.01 }).observe(box);
    } else { inView = true; update(); }
    if (rm && rm.addEventListener) rm.addEventListener('change', function () { if (reduced() && !v.paused) v.pause(); else update(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) { if (!v.paused) v.pause(); } else update(); });
  }

  // ---------------------------------------------------------------- Floating "Book a call" pill
  // Rendered by the Book a call section. Shows after the hero, hides while the booking section is on screen,
  // while a field is focused (phone keyboard) and while the cookie banner, menu or cart drawer is open.
  function setupFloat(el) {
    if (el.hasAttribute('data-dbg-ready')) return;
    el.setAttribute('data-dbg-ready', '');
    // escape section stacking contexts; drop a copy left behind by a theme-editor section reload
    var sid = el.getAttribute('data-section');
    document.querySelectorAll('body > [data-dbg-float]').forEach(function (old) { if (old !== el && old.getAttribute('data-section') === sid) old.remove(); });
    if (el.parentNode !== document.body) document.body.appendChild(el);
    var target = document.getElementById(el.getAttribute('data-target') || 'book');
    if (!target) { el.hidden = true; return; }
    var bookOn = false, typing = false, ticking = false;
    var startAt = parseFloat(el.getAttribute('data-start') || '0.6');
    var baseH = window.visualViewport ? visualViewport.height : innerHeight;
    function isField(n) {
      if (!n || n === document.body) return false;
      if (n.isContentEditable) return true;
      var t = (n.tagName || '').toLowerCase();
      if (t === 'textarea' || t === 'select' || t.indexOf('shopify-forms') === 0) return true;
      if (t === 'input') return !/^(checkbox|radio|button|submit|reset|range|color|file|image)$/i.test(n.type || '');
      return t === 'iframe' && !!n.closest('[data-dbg-book]');
    }
    function overlayOpen() {
      var pc = document.getElementById('shopify-pc__banner');
      if (pc && pc.offsetHeight && getComputedStyle(pc).visibility !== 'hidden') return true;
      var cart = document.getElementById('kaching-cart');
      if (cart && getComputedStyle(cart).visibility !== 'hidden') return true;
      var md = document.querySelector('.menu-drawer');
      return !!(md && getComputedStyle(md).visibility !== 'hidden' && md.getBoundingClientRect().right > 0);
    }
    function render() {
      ticking = false;
      if (window.visualViewport) {
        var h = visualViewport.height;
        if (h > baseH) baseH = h;
        if (baseH - h > 150 && isField(document.activeElement)) typing = true;
      }
      var show = window.scrollY > innerHeight * startAt && !bookOn && !typing && !overlayOpen();
      el.classList.toggle('is-on', show);
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
      el.tabIndex = show ? 0 : -1;
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(render); } }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bookOn = en.isIntersecting; });
        queue();
      }, { rootMargin: '0px 0px -20% 0px', threshold: 0 }).observe(target);
    }
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', queue);
    if (window.visualViewport) visualViewport.addEventListener('resize', queue);
    document.addEventListener('focusin', function (e) { typing = isField(e.target); queue(); });
    document.addEventListener('focusout', function () { setTimeout(function () { typing = isField(document.activeElement); queue(); }, 60); });
    setInterval(queue, 1200); // cheap re-check for banners/drawers that open without scrolling
    el.addEventListener('click', function (e) {
      e.preventDefault();
      var smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      target.scrollIntoView({ block: 'start', behavior: smooth ? 'smooth' : 'auto' });
      var box = target.querySelector('[data-dbg-book]');
      if (box && DBX.openBook) DBX.openBook(box, DBX.lastSubmit || null, false);
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      try { target.focus({ preventScroll: true }); } catch (err) {}
      bookOn = true; queue();
      try { el.dispatchEvent(new CustomEvent('dbg:book-float', { bubbles: true })); } catch (err) {}
    });
    render();
  }

  // ---------------------------------------------------------------- Book a call (Calendly)
  var calLoading = null;
  function loadCalendly() {
    if (window.Calendly && window.Calendly.initInlineWidget) return Promise.resolve(window.Calendly);
    if (calLoading) return calLoading;
    calLoading = new Promise(function (resolve, reject) {
      var sc = document.createElement('script');
      sc.src = CAL_JS;
      sc.async = true;
      sc.onload = function () { window.Calendly && window.Calendly.initInlineWidget ? resolve(window.Calendly) : reject(new Error('Calendly missing')); };
      sc.onerror = function () { calLoading = null; reject(new Error('Calendly failed to load')); };
      document.head.appendChild(sc);
    });
    return calLoading;
  }

  /** scheduling URL with prefill params (Calendly reads name, email, a1..a10, location from the link) */
  DBX.calendlyUrl = function (base, prefill, phoneParam, hideDetails) {
    var u;
    try { u = new URL(base, location.href); } catch (e) { return base; }
    u.searchParams.set('hide_gdpr_banner', '1');
    if (hideDetails) u.searchParams.set('hide_event_type_details', '1');
    // site colors (Calendly reads hex without '#'; paid Calendly plans only)
    if (DBX.calColors) Object.keys(DBX.calColors).forEach(function (k) { var v = String(DBX.calColors[k] || '').replace('#', ''); if (/^[0-9a-fA-F]{6}$/.test(v)) u.searchParams.set(k, v); });
    prefill = prefill || {};
    if (prefill.name) u.searchParams.set('name', prefill.name);
    if (prefill.email) u.searchParams.set('email', prefill.email);
    if (prefill.phone && phoneParam && phoneParam !== 'none') u.searchParams.set(phoneParam, prefill.phone);
    return u.toString();
  };

  DBX.openBook = function (box, prefill, scroll) {
    var host = box.querySelector('[data-dbg-cal]');
    if (!host) return Promise.resolve();
    DBX.calColors = { background_color: box.getAttribute('data-cal-bg'), text_color: box.getAttribute('data-cal-text'), primary_color: box.getAttribute('data-cal-accent') };
    var url = DBX.calendlyUrl(box.getAttribute('data-url'), prefill, box.getAttribute('data-phone'), box.hasAttribute('data-hide-details'));
    if (scroll) box.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    if (box.getAttribute('data-loaded-url') === url) return Promise.resolve();
    box.setAttribute('data-loaded-url', url);
    box.classList.add('is-loading');
    return loadCalendly().then(function (C) {
      if (box.getAttribute('data-loaded-url') !== url) return;
      host.innerHTML = '';
      C.initInlineWidget({ url: url, parentElement: host });
      box.classList.remove('is-loading');
      box.classList.add('is-loaded');
    }, function () {
      box.removeAttribute('data-loaded-url');
      box.classList.remove('is-loading');
      box.classList.add('is-failed');
    });
  };

  function setupBook(box) {
    if (box.hasAttribute('data-dbg-ready')) return;
    box.setAttribute('data-dbg-ready', '');
    var go = function () { if (!box.hasAttribute('data-loaded-url')) DBX.openBook(box, DBX.lastSubmit || null, false); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '300px 0px' });
      io.observe(box);
    } else go();
  }

  function setupHeroLinks(root) {
    root.querySelectorAll('a[data-dbg-hide-missing]').forEach(function (a) {
      var id = (a.getAttribute('href') || '').charAt(0) === '#' ? a.getAttribute('href').slice(1) : '';
      if (id && !document.getElementById(id)) a.hidden = true;
    });
  }
  // any in-page link to a Book a call section opens it right away
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a || a.hasAttribute('data-dbg-book-go')) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    var box = t && t.querySelector('[data-dbg-book]');
    if (box && !box.hasAttribute('data-loaded-url')) DBX.openBook(box, DBX.lastSubmit || null, false);
  });

  DBX.init = function (root) {
    root = root || document;
    root.querySelectorAll('[data-dbg-book]').forEach(setupBook);
    setupHeroLinks(document);
    root.querySelectorAll('[data-dbg-form]').forEach(setupForm);
    root.querySelectorAll('[data-dbg-video]').forEach(setupVideo);
    root.querySelectorAll('[data-dbg-float]').forEach(setupFloat);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { DBX.init(); });
  else DBX.init();
  document.addEventListener('shopify:section:load', function (e) { DBX.init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id) document.querySelectorAll('body > [data-dbg-float][data-section="' + id + '"]').forEach(function (f) { f.remove(); });
  });
})();
